//На нужной странице вызывается функция с данными request (url, method, data). Далее по результату ответа создается действие
async function getDataFromAjax(url, method, formData) {
    const res = await fetch(url, {
        method: method,
        body: formData !== undefined ? formData : null
    })
    return res.json()
}

//Отправка формы
$('.form').on('submit', function (e) {
    e.preventDefault();

    const url = $(this).attr('action');
    const method = $(this).attr('method');
    // let formData = new FormData();
    const handlesResultFuncAnswer = $(this).attr('data-func-answer');
    const handlesResultFuncSet = $(this).attr('data-func-set');
    const popupActive = $('.popup--active');
    const form = $(this);

    // if (!captcha.length) {
    //     // Выводим сообщение об ошибке
    //     $('#recaptchaError').text('* Вы не прошли проверку "Я не робот"');
    //     console.log(111, 'не прошел')
    // } else {
    //     // получаем элемент, содержащий капчу
    //     $('#recaptchaError').text('');
    //     console.log(111, 'прошел')
    // }

    /*grecaptcha.ready(function() {
        grecaptcha.execute('6LegL8QcAAAAADO1TgGfQmdIepdvxi1pzP-JQa4D', {action: 'submit'}).then(function(token) {

            // document.getElementById('g-recaptcha-response').value=token;
            recaptchaToken = token

            const formDataKey = new FormData()

            formDataKey.append(`recaptcha_token`, recaptchaToken)

            fetch('/ajax/check-recaptcha', {
                method: 'POST',
                body: formDataKey
            })
                .then(response => response.json())
                .then(result => {
                    console.log(999, result)

                    if (result === 'success') {
                        if (!validator($(this))) {
                            const formData = window[handlesResultFuncSet](form);

                            // showPreloader();

                            //Если форма в popup, закрываем его
                            if (popupActive !== undefined) {
                                closeModalWindow(popupActive);
                            }

                            getDataFromAjax(url, method, formData)
                                .then(res => {
                                    // hidePreloader();
                                    window[handlesResultFuncAnswer](form, res);
                                })
                        }
                    } else {
                        alert('Вы бот')
                        if (popupActive !== undefined) {
                            closeModalWindow(popupActive);
                        }
                    }
                })
        });
    });*/

    if (!validator($(this))) {
        const formData = window[handlesResultFuncSet](form);

        // showPreloader();

        // //Если форма в popup, закрываем его
        // if (popupActive !== undefined) {
        //     closeModalWindow(popupActive);
        // }

        // getDataFromAjax(url, method, formData)
        //     .then(res => {
        //         // hidePreloader();
        //         window[handlesResultFuncAnswer](form, res);
        //     })
    }

    /*if (!validator($(this))) {
        const formData = window[handlesResultFuncSet]($(this));

        // showPreloader();

        //Если форма в popup, закрываем его
        if (popupActive !== undefined) {
            closeModalWindow(popupActive);
        }

        getDataFromAjax(url, method, formData)
            .then(res => {
                // hidePreloader();
                window[handlesResultFuncAnswer]($(this), res);
            })
    }*/

    // let stingData = '?'
    // for (const  key of formData.keys()) {
    //     console.log(`${key}: ${formData.get(key)}`);
    //     stingData = stingData + `${key}=${formData.get(key)}&`
    // }
    // console.log(555, stingData)

});

